module.exports = {
	et: {
		path: 'et',
		locale: 'Eesti',
		localeShort: 'et',
		default: true
	},
	en: {
		path: 'en',
		locale: 'English',
		localeShort: 'en'
	}
};
